import React, { lazy } from "react";
import { Route } from "react-router";
import routeURL from "./routeConstants";

/**
 * Reporting & Analytics routes.
 *
 * Mounted OUTSIDE the `Main` layout in src/config/routes.js, unlike most of the
 * app. The design is a full-bleed dashboard with its own top nav, brand mark and
 * period selector — rendering it inside Main put it in a column beside the
 * global sidebar and under the global header, so there were two navigation bars
 * and two brand marks on screen at once, and the hero never reached its
 * intended width.
 *
 * Leaving Main also leaves the auth wrapper that sits under it, so the login
 * check has to happen somewhere else. It's done in ReportingLayout rather than
 * with the shared ProtectedRoute component, because that one is built on
 * react-router-dom v5 while this app's top-level Router is react-router v3 —
 * a v5 <Route> is not a valid v3 route definition, and putting one at the top
 * level of a v3 tree is asking for a routing bug that only shows up for logged
 * out users. A plain v3 Route here (matching /onboarding, /landing and the
 * other chrome-less routes) plus an explicit token check in the layout keeps
 * both behaviours without mixing router versions.
 *
 * Access control beyond "is logged in" belongs on the API side, as it does for
 * the two validation dashboards.
 *
 * Lazy-loaded: these screens pull in their own stylesheet and web fonts, and
 * there's no reason for any of that to sit in the initial bundle for users who
 * never open them.
 *
 * Only Overview exists so far. The other seven screens are listed in
 * config/navigation.js (which drives the nav bar) with `built: false`, so their
 * tabs render inert rather than linking somewhere that would 404. Adding a
 * screen means a page, a route here, and flipping that flag.
 */
const Overview = lazy(() => import("../pages/Overview"));

const reportingRoutes = (
  <>
    <Route path={routeURL.OVERVIEW} component={Overview} />
  </>
);

export default reportingRoutes;
